import { ChangeEvent, useState } from 'react';
import useErrors from '../../../../../hooks/useErrors';
import { isPasswordValid } from '../../../../../utils/isPasswordValid';

export default function useHandleInputChanges() {
  const [newPassword, setNewPassword] = useState('');
  const [newPasswordConfirmation, setNewPasswordConfirmation] = useState('');

  const {
    setError, removeError, getErrorMessageByFieldName, errors,
  } = useErrors();

  function handleNewPasswordChange(event: ChangeEvent<HTMLInputElement>) {
    setNewPassword(event.target.value);

    if (!isPasswordValid(event.target.value)) {
      setError({ field: 'newPassword', message: 'A senha deve conter pelo menos 8 caracteres, uma letra maiúscula, uma letra minúscula, um número e um caractere especial!' });
    } else {
      removeError('newPassword');
    }

    if (event.target.value !== newPasswordConfirmation) {
      setError({ field: 'newPasswordConfirmation', message: 'Senhas divergentes' });
    } else if (event.target.value === newPasswordConfirmation) {
      removeError('newPasswordConfirmation');
    }
  }

  function handleNewPasswordConfirmationChange(event: ChangeEvent<HTMLInputElement>) {
    setNewPasswordConfirmation(event.target.value);

    if (event.target.value !== newPassword) {
      setError({ field: 'newPasswordConfirmation', message: 'Senhas divergentes' });
    } else {
      removeError('newPasswordConfirmation');
    }
  }

  return {
    newPassword,
    newPasswordConfirmation,
    handleNewPasswordChange,
    handleNewPasswordConfirmationChange,
    getErrorMessageByFieldName,
    errors,
  };
}
